import { useState } from 'react';
import svgPaths from '../../../assets/imports/PgrmLandingPageDeslogada/svg-huqtkssm9g';
import imgAnmLogo from '../../../assets/ANM-logo.png';
import imgSerpro from '../../../assets/serpro_blue_logo.png';
import { lojaSerpro } from '../../../environment/environment';
import styles from './LandingFooter.module.scss';

const isLojaSerproHabilitada =
  String(lojaSerpro.habilitada).toLowerCase() === 'true';

const COLUMNS: {
  title: string;
  items: { label: string; href: string; external?: boolean }[];
}[] = [
  {
    title: 'ANM',
    items: [
      {
        label: 'Página Inicial',
        href: 'https://www.gov.br/anm/pt-br',
        external: true,
      },
      {
        label: 'Serviço de Informação ao Cidadão - SIC',
        href: 'https://www.gov.br/anm/pt-br/acesso-a-informacao/servico-de-informacao-ao-cidadao-sic-1',
        external: true,
      },
      {
        label: 'Últimas Notícias',
        href: 'https://www.gov.br/anm/pt-br/assuntos/noticias',
        external: true,
      },
    ],
  },
  {
    title: 'Serviços',
    items: [
      { label: 'Arrecadação-CFEM', href: '/info-arrecadacao' },
      { label: 'DIEF-CFEM', href: '/info-dief' },
    ],
  },
  ...(isLojaSerproHabilitada
    ? [
        {
          title: 'Contratação',
          items: [
            { label: 'Loja SERPRO', href: lojaSerpro.url, external: true },
            { label: 'API Integra', href: '#', external: false },
            { label: 'Preços', href: '#', external: false },
            { label: 'Suporte e Contato', href: '#', external: false },
          ],
        },
      ]
    : []),
];

export function LandingFooter() {
  const [highlighted, setHighlighted] = useState(false);

  const scrollToContact = () => {
    document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' });
    setHighlighted(true);
    setTimeout(() => setHighlighted(false), 2800);
  };

  return (
    <div className={styles.footer} data-name='footer'>
      <button
        className={styles.fab}
        onClick={scrollToContact}
        type='button'
        aria-label='Fale Conosco'
      >
        <i className={`fas fa-comment-dots`} aria-hidden='true' />
        <span>Fale Conosco</span>
      </button>

      <div className={styles.top}>
        <div className={styles.leftCol}>
          <div
            id='contato'
            className={`${styles.contactBox} ${highlighted ? styles.contactBoxHighlighted : ''}`}
          >
            <div className={styles.phoneIcon}>
              <svg fill='none' height='20' viewBox='0 0 20 20' width='20'>
                <g clipPath='url(#clip-phone)'>
                  <path
                    d={svgPaths.p11ad8000}
                    stroke='white'
                    strokeLinecap='round'
                    strokeWidth='2'
                  />
                </g>
                <defs>
                  <clipPath id='clip-phone'>
                    <rect fill='white' height='20' width='20' />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div>
              <p className={styles.doubtText}>Surgiu alguma dúvida?</p>
              <p className={styles.contactText}>
                Entre em contato através dos e-mails abaixo.
              </p>
            </div>
            <p className={styles.emailLabel}>
              Dúvidas DIEF-CFEM:{' '}
              <a href='mailto:corfem@anm.gov.br' className={styles.emailLink}>
                corfem@anm.gov.br
              </a>
            </p>
            <p className={styles.emailLabel}>
              Dúvidas Arrecadação-CFEM:{' '}
              <a href='mailto:receitas@anm.gov.br' className={styles.emailLink}>
                receitas@anm.gov.br
              </a>
            </p>
          </div>
          <div className={styles.logos}>
            <img alt='ANM' className={styles.anm} src={imgAnmLogo} />
            <img alt='SERPRO' className={styles.serpro} src={imgSerpro} />
          </div>
        </div>
        <div className={styles.columns}>
          {COLUMNS.map((col) => (
            <div key={col.title} className={styles.column}>
              <p className={styles.colTitle}>{col.title}</p>
              <div className={styles.colItems}>
                {col.items.map((item) =>
                  item.external ? (
                    <a
                      key={item.label}
                      href={item.href}
                      className={styles.colItem}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {item.label}
                    </a>
                  ) : (
                    <a
                      key={item.label}
                      href={item.href}
                      className={styles.colItem}
                    >
                      {item.label}
                    </a>
                  ),
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.bottom}>
        <p>© 2026 SERPRO - Todos os direitos reservados</p>
        <div className={styles.bottomLinks}>
          <a
            href='https://www.gov.br/governodigital/pt-br/acessibilidade-e-usuario/acessibilidade-digital'
            target='_blank'
            rel='noopener noreferrer'
            className={styles.bottomLink}
          >
            Acessibilidade Digital
          </a>
        </div>
      </div>
    </div>
  );
}
